import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';
import ReactDOM from 'react-dom';

import {OpenDirection, Position} from './types';
import {useSubMenuPosition} from './useSubMenuPosition';

interface SubMenuProps {
  position: Position;
  direction: OpenDirection;
  width?: string;
  maxHeight?: string;
  children: React.ReactNode;
}

/**
 * Generic submenu component that renders in a portal with smart positioning
 */
export const SubMenu: React.FC<SubMenuProps> = ({
  position,
  direction,
  width = '350px',
  maxHeight = '400px',
  children,
}) => {
  const subMenuPosition = useSubMenuPosition(position, direction);

  return ReactDOM.createPortal(
    <Tailwind>
      <div
        className={`fixed bg-white rounded overflow-y-auto p-6 z-[10000] border border-moon-200 shadow-[0_2px_8px_moon-100]`}
        style={{
          ...subMenuPosition,
          width,
          maxHeight,
        }}>
        {children}
      </div>
    </Tailwind>,
    document.body
  );
};
